export type ComponentWithCssSelector = {
	cssSelector: string
}

export function withCssSelector<C>(component: C, className: string): C & ComponentWithCssSelector {
	const withClassName = component as C & ComponentWithCssSelector;
	withClassName.cssSelector = className;
	return withClassName;
}
